import React from "react";
import {graphql} from "gatsby";
import {Menu} from "../components/menu/menu";
import ReactMarkdown from "react-markdown";
import {StrapiLayout, Jumbo, Divider} from "@klear/open-site";

const {Helmet} = require("react-helmet");

const styles = require("../styles/legal-document.module.scss");

const description = 'We’ve pulled together some important legal documents to help you understand how Klear works with and protects its website visitors, customers, and partners.'
const topImage = "https://klear.com/images/new/tosHeader.gif";

export default ({data}) => {
    const document = data.allStrapiLegalDocument.edges[0].node;
    const footerData = data.strapiFooter;

    return (
        <StrapiLayout footerProps={footerData}>
            <Helmet>
                <title>{document.title}</title>
                <meta name="description" content={description}/>
                {topImage &&
                <meta name="image" content={topImage}/> &&
                <meta property="og:image" content={topImage}/>}
            </Helmet>
            <div className={styles.container}>
                <div className={styles.upper}>
                    <Jumbo topImage={topImage} title={'Legal Stuff'} subTitle={description}/>
                </div>
                <div className={styles.stickyNav}>
                    <Menu tab={document.slug}/>
                </div>
                <div className={`${styles.document}`}>
                    <div className={styles.innerHeader}>{document.innerHeader}</div>
                    <ReactMarkdown className={styles.content} source={document.content.data.content}/>
                </div>
            </div>
        </StrapiLayout>
    )
}
export const query = graphql`
  query($slug: String!) {
  allStrapiLegalDocument(filter: { slug: { eq: $slug } }) {
        edges {
          node {
            title
            description
            innerHeader
            innerTitle
            slug
            content {
                data {
                    content
                }
            }
          }
        }
      }
      strapiFooter {
        columns {
          title
          links {
            text
            url
          }
        }
        backgroundShapes {
            color
            shapeId
            side
          }
      }
  }
`